import React from 'react';
import classnames from 'classnames';

import "./scrapbook-icon.scss";

export interface IProps {
    onClick?: () => void;
}
export interface IState {
    
}

export class ScrapbookIcon extends React.Component <IProps, IState> {
    constructor(props: IProps) {
        super(props);
    }

    public render(){
        return <div className={classnames("scrapbook-icon-root")} onClick={this.props.onClick}>
                    <div className="_decorative-rectangles">
                        <div className="_decorative-rectangle"></div>
                        <div className="_decorative-rectangle"></div>
                        <div className="_decorative-rectangle"></div>
                        <div className="_decorative-rectangle"></div>
                        <div className="_decorative-rectangle"></div>
                    </div>
                    <div className="_title">
                        note <br/> book
                    </div>
               </div>
    }
}